import React, { useState } from 'react';
import type { TitleElement } from 'models/forms/formElements/TitleElement';

type Props = {
  element: TitleElement;
  isEditing: boolean;
  onUpdate: (updatedElement: TitleElement) => void;
};

const TitleElementComponent: React.FC<Props> = ({ element, isEditing, onUpdate }) => {
  const [text, setText] = useState(element.value || '');

  if (isEditing) {
    return (
      <div>
        <p className="mb-1 text-sm text-gray-700">Title text</p>
        <input
          type="text"
          value={text}
          onChange={(e) => {
            const next = e.target.value;
            setText(next);
            onUpdate({ ...element, value: next });
          }}
          className="block w-full px-3 py-2 border border-gray-300 rounded"
        />
      </div>
    );
  }

  return (
    <h3 className="text-xl font-semibold text-gray-900">
      {element.value}
    </h3>
  );
};

export default TitleElementComponent;
